import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { EDeliveryService } from "src/app/pages/users/e-delivery/services/e-delivery.service";
import { Child, Variant } from "src/app/pages/users/q-commerce/models/category-group.model";
import { ServicesService } from "src/app/pages/users/service/services/services.service";

@Component({
  selector: "app-change-merchant-modal",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./change-merchant-modal.component.html",
  styleUrl: "./change-merchant-modal.component.scss"
})
export class ChangeMerchantModalComponent {
  @Input() isDeliveryBusiness: boolean = false;
  selectedProduct!: Child;
  selectedVariant!: Variant;
  changeMerchantModalRef!: NgbModalRef;
  isDifferentServiceMerchant!: boolean;
  @Output() onModalClosed = new EventEmitter<{ product: Child; variant?: Variant }>();
  @ViewChild("changeMerchantModal", { static: true }) changeMerchantModal!: TemplateRef<any>;
  config: NgbModalOptions = { size: "sm", centered: true, backdrop: "static" };

  constructor(private modalService: NgbModal, private edeliveryService: EDeliveryService, private servicesService: ServicesService) {}

  openModal(product: Child, variant?: Variant, isDifferentServiceMerchant?: boolean): void {
    this.changeMerchantModalRef = this.modalService.open(this.changeMerchantModal, { ...this.config });
    this.selectedProduct = product;
    if (isDifferentServiceMerchant) this.isDifferentServiceMerchant = isDifferentServiceMerchant;
    if (variant) {
      this.selectedVariant = variant;
    }
  }

  closeModal(): void {
    this.changeMerchantModalRef.close();
  }

  clearCart(): void {
    if (this.isDeliveryBusiness) {
      localStorage.removeItem("deliveryCartItems");
      this.edeliveryService.updateCartItems([]);
    } else {
      localStorage.removeItem("serviceCartItems");
      localStorage.removeItem("cartServiceItemMainCategory");
      this.servicesService.updateCartItems([]);
    }
    this.closeModal();
    this.onModalClosed.emit({
      product: this.selectedProduct,
      variant: this.selectedVariant
    });
  }
}
